import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HistoricoConsultasComponent } from './historico-consultas.component';


const routes: Routes = [
  { path: '', component: HistoricoConsultasComponent },



];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HistiricoConsultasRoutingModule { }
